<template>
  <TabsList
    v-bind="forwarded"
    class="flex data-[orientation=horizontal]:flex-row data-[orientation=vertical]:flex-col relative gap-2 px-4 z-0"
  >
    <slot />
  </TabsList>
</template>

<script setup>
import { TabsList, useForwardProps } from 'radix-vue';

const props = defineProps({
  as: {
    type: String,
    required: false,
    default: 'div',
  },
  asChild: {
    type: Boolean,
    required: false,
    default: false,
  },
  loop: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const forwarded = useForwardProps(props);
</script>
